import axios from 'axios'

export default axios.create({'baseURL': 'https://react-quiz-73806.firebaseio.com'})